module.exports = __webpack_public_path__ + "static/media/Tire_a_green.38faead7.png";